var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableActionDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42859 5.00129H18.5714M6.42859 5.00129V4.287C6.42859 3.3398 6.80486 2.43139 7.47463 1.76162C8.1444 1.09185 9.05282 0.715576 10 0.715576C10.9472 0.715576 11.8556 1.09185 12.5254 1.76162C13.1952 2.43139 13.5714 3.3398 13.5714 4.287V5.00129M7.85716 9.28909V15.0056M12.1429 9.28909V15.0056M3.57145 5.00129H16.4286V17.8584C16.4286 18.2373 16.278 18.6007 16.0102 18.8686C15.7423 19.1364 15.3789 19.287 15 19.287H5.00002C4.62113 19.287 4.25777 19.1364 3.98986 18.8686C3.72196 18.6007 3.57145 18.2373 3.57145 17.8584V5.00129Z",
    stroke: "#AA1A5F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableActionDelete);
export default __webpack_public_path__ + "static/media/table-action-delete.481f2b70e752d5b2a53932c3a8358e21.svg";
export { ForwardRef as ReactComponent };